module.exports = __webpack_public_path__ + "img/VetoSansCond-Bold.73d750ee.svg";